function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import * as S from './Legend.styles';
const Legend = /*#__PURE__*/React.forwardRef(({
  children,
  ...legendProps
}, ref) => {
  return /*#__PURE__*/React.createElement(S.StyledLegend, _extends({
    ref: ref
  }, legendProps), children);
});
export { Legend };